// You can replace this with process.env.EXPO_PUBLIC_API_BASE_URL or your preferred env variable

export const BASE_API_URL =
  process.env.EXPO_PUBLIC_API_BASE_URL || "https://usesparrow.com";
export const BASE_URL =
  process.env.EXPO_PUBLIC_BASE_URL || "https://usesparrow.com";
export const APP_BASE_URL =
  process.env.EXPO_PUBLIC_APP_BASE_URL || "https://usesparrow.com";
export const ECS_BASE_API_URL =
  process.env.EXPO_PUBLIC_ECS_BASE_URL || "https://api.usesparrow.com";
export const WS_BASE_URL =
  process.env.EXPO_PUBLIC_WS_BASE_URL || "wss://api.usesparrow.com";

export const FB_PIXEL_ID = process.env.EXPO_PUBLIC_FB_PIXEL_ID;

export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyAR7F7nEwlLm9zFNWFlBcJ1fzgA3ovCLrA",
  authDomain: "pasero-main-prod.firebaseapp.com",
  projectId: "pasero-main-prod",
  storageBucket: "pasero-main-prod.firebasestorage.app",
  messagingSenderId: "198717928667",
  appId: "1:198717928667:web:b0291266dd696c666208fe",
  databaseURL: "https://pasero-main-prod-default-rtdb.firebaseio.com",
};

export const IAP_MONTHLY_PLANS = {
  id: 8,
  sku: "com.usesparrow.sparrowai.15mo",
  name: "$8/month",
  price: 8 * 12,
  trackingPrice: 15,
};

// IAP: Single subscription SKU
export const IAP_ANNUAL_PLANS = {
  id: 7,
  sku: "com.usesparrow.sparrowai.84yr",
  name: "$7/month",
  price: 7 * 12,
  trackingPrice: 84,
};

export const DEFAULT_IAP_SUBSCRIPTION_PLAN_SKU = IAP_ANNUAL_PLANS;

// Stripe publishable key for web payments
export const STRIPE_PUBLISHABLE_KEY =
  process.env.EXPO_PUBLIC_STRIPE_PUBLISHABLE_KEY ||
  "pk_live_51Oox7EJ07YR7keItdVFMeAelyDTRqK7TWfmY22i8TQrGQMVpk4iOp1DhKfTEKT1TvltBC4gjeRMhieXtEcVaYpA400fjfoWxNx";
